<template>
  <div class="info-container">
    <div class="content">
      <template v-if="itemList.length > 0 || scrollFlag">
        <Item
          v-for="v in itemList"
          :key="v.articleId"
          :every="v"
          :curcer="v.articleId"
          @itemClick="goDetail"
        >
        </Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
      </template>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import Item from "@/components/pager/Item";
import Scroll from "@/components/paging/scroll";
import mixin from "@/mixins";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  data() {
    return {
      params: {
        articleType: 5,
        type: 0,
        pageNo: 1,
      },
    };
  },
  mixins: [mixin],
  created() {
    // 论文列表
    this.getItemList(this.params);
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "msgDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  min-height: 1000px;
}
</style>
